<template>
  <Modal
    actions
    name="DELETE_SELECTED_APPOINTMENT_FILES"
    :title="$t('appointment.label.deleteSelectedFiles')"
  >
    <template v-slot:body>
      <h3 class="red--text">
        {{ $t('upload.delete.title') }}
      </h3>
      <p>
        {{
          $t('upload.delete.deleteSelected', {
            value: appointmentFilesToDelete.length,
          })
        }}
      </p>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal"
        :disabled="isAppointmentFilesDeleting"
        elevation="0"
        color="grey darken-1"
        text
      >
        {{ $t('deleteModal.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="handleDelete"
        :loading="isAppointmentFilesDeleting"
        elevation="0"
        class="ml-5"
        color="red"
        dark
      >
        {{ $t('deleteModal.buttons.deleteSelectedFiles') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalAppointmentDeleteSelectedFiles',

  props: {
    handleDelete: {
      type: Function,
      required: false,
    },
  },

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['appointmentFilesToDelete', 'isAppointmentFilesDeleting']),
  },

  methods: {
    ...mapMutations(['closeAllModals']),

    closeModal() {
      this.$emit('resetSelectedFiles')
      this.closeAllModals()
    },
  },
}
</script>
